export const colors = {
  // primary: '#1E42A6',
  red: '#F5222D',
  yellow: '#FFF065',
  kakao: '#FFE402',
  naver: '#03C75A',
  green: { 0: '#34A853', 1: '#7CD296' },
  brown: { 0: '#C77840', 1: '#FFF9EA' },
  grey: {
    0: '#ffffff',
    1: '#FAFAFA',
    2: '#F5F5F5',
    3: '#EBEBEB',
    4: '#DCDCDC',
    5: '#BFBFBF',
    6: '#909090',
    7: '#6B6B6B',
    8: '#535353',
    9: '#414141',
    10: '#2D2D2D',
    11: '#191919',
    12: '#000000',
  },
  primary: {
    0: '#F8FAFF',
    1: '#F1F5FF',
    2: '#E4EBFF',
    3: '#D5E0FF',
    4: '#C2D2FF',
    5: '#A3BBFE',
    6: '#89A7FB',
    7: '#688DF4',
    8: '#4A71DD',
    9: '#335AC7',
    10: '#1E42A6',
    11: '#0E2E87',
    12: '#062069',
  },
  // blue, gray는 deprecate예정
  blue: {
    0: '#F8FAFF',
    1: '#F3F7FF',
    2: '#D1DDFF',
    3: '#5578F0',
    4: '#1976D2',
    5: '#E7EFFF',
    6: '#F0F2F5',
    7: '#335CCF',
    8: '#3C5FBF',
    9: '#353C51',
    10: '#E2E9F9',
  },
  gray: {
    0: '#ffffff',
    1: '#FAFAFA',
    2: '#F5F5F5',
    3: '#E8E8E8',
    4: '#DCDCDC',
    5: '#BEBEBE',
    6: '#919191',
    7: '#737373',
    8: '#414141',
    9: '#121212',
    10: '#000000',
    11: '#545454',
    12: '#222222',
  },
  secondaryBlue: {
    0: '#E9ECF6',
    1: '#1E42A6',
    faq: '#EFF6FF',
  },
  secondaryRed: {
    0: '#F6E9E9',
    1: '#A61E20',
    light: '#FFF8F8',
    faq: '#FFEFEF',
  },
  secondaryYellow: {
    0: '#FEFCE8',
    1: '#FFF085',
  },
  dealer: {
    0: '#2D3E50',
    1: 'rgba(255, 255, 255, 0.20)',
  },
  gradient: {
    'blueGradient-blue-to-blue': 'linear-gradient(276deg, #535AFF 0.12%, #397AFF 50%, #10ACFF 99.88%)',
  },
};
